export const reservationOptions = [
    { label: "Default", value: "DEFAULT", name: "reservationOptionField" },
    { label: "Daily", value: "DAILY", name: "reservationOptionField" },
];
